import { CASH_TXN_SCHEMA, BUSINESS_SCHEMA } from '../schema';
import { Q } from '@nozbe/watermelondb';
import { database } from '../index';

const cash_txn = database.collections.get(CASH_TXN_SCHEMA);

export const getCashTxnByID = async (id) => await cash_txn.find(id);

export const observeCashTxnCountByBusiness = (businessId) =>
  cash_txn.query(Q.on(BUSINESS_SCHEMA, 'id', businessId)).observeCount();

export const getAttachmentsToCashTxnSync = async () => {
  try {
    let records = await cash_txn
      .query(Q.where("attachment", Q.notLike("[]")))
      .fetch();
    if (records?.length) {
      const filteredRecords = records.filter((record) => {
        const attachments = record.attachment || [];
        return attachments.some((attachment) =>
          attachment?.file?.startsWith?.("data"),
        );
      });
      return filteredRecords;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching cash_txn attachment records:", error);
    return [];
  }
};
